<template>
    <div
        class="role-name-input"
        :class="clazz"
        @submit="preventSubmit"
    >
        <v-form ref="roleNameform">
            <v-form-item
                v-model="errMsg"
                name="roleName"
                error-placement="top-right"
                :rules="ruleArr"
            >
                <v-input
                    v-model="roleName"
                    name="roleName"
                    placeholder="角色名称"
                    :limit="10"
                    autofocus
                    class="page-roleName"
                    @input="roleNameinput"
                />
            </v-form-item>
        </v-form>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        clazz: {
            type: String,
            default: '',
        },
        val: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            roleName: '',
            errMsg: '',
            ruleArr: [
                { required: true, message: '请输入角色名', trim: true },
                { maxLength: 10, message: '角色名称字数超限', trim: true, custom: true },
                { validate: this.validateRule, message: '角色名称不可包含 \\ / * \'"', trim: true },
            ],
        };
    },

    watch: {
        val: {
            immediate: true,
            handler() {
                this.roleName = this.val;
            },
        },
    },

    mounted() {
        if (this.val) {
            this.$refs.roleNameform.submit();
        }
    },

    methods: {
        roleNameinput(val) {
            this.$emit('input', val);
        },

        preventSubmit(e) {
            e.preventDefault();
        },

        getErrMsg() {
            // this.$refs.roleNameform.submit();
            if (this.errMsg) {
                this.$refs.roleNameform.focusError();
            }
            return this.errMsg;
        },

        validateRule(val) {
            const reg = /[*"/'\\]/im;
            let isValid = true;

            if (reg.test(val)) {
                isValid = false;
            }

            return isValid;
        },
    },
};
</script>

<style lang="less">
.page-roleName {
    text-align: left;
    .v-input--simple__limit {
        span:first-child {
            margin-right: -3px;
        }
        &--total {
            margin-left: 0px;
        }
    }
}
</style>
